var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#9BA0B1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3 17h10.002C13 17 13 7.203 13 4H3v13zm12 0c0 1.105-.897 2-1.998 2H2.998C1.895 19 1 18.107 1 17V4c-.552 0-1-.444-1-1 0-.552.445-1 1-1h5c0-1.105.895-2 2-2s2 .895 2 2h5c.552 0 1 .444 1 1 0 .552-.444 1-1 1v13zM9 6.998C9 6.447 9.444 6 10 6c.552 0 1 .446 1 .998v7.004c0 .551-.444.998-1 .998-.552 0-1-.446-1-.998V6.998zm-4 0C5 6.447 5.444 6 6 6c.552 0 1 .446 1 .998v7.004c0 .551-.444.998-1 .998-.552 0-1-.446-1-.998V6.998z",
    transform: "translate(-457 -501) translate(457 501)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f0624a82b4678f89a6cbe855763b31be.svg";
export { ForwardRef as ReactComponent };